/**
 *
 * @param extended  the first argument must be an imported variable.
 * @param extension
 */
export const extend = (extended, extension) => { };
